
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { Context } from '@nuxt/types'
import { OnMounted, WithAsyncData, WithHead } from '~/core/vue.types'
import StaticPageHero from '~/components/sections/StaticPageHero.vue'
import { $api } from '~/plugins/axios'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import { useSEOMetaComposer } from '~/composables/seo.composable'

interface AsyncComponentData {
  title: string,
  content: string,
}

@Component({
  components: {
    StaticPageHero,
  },
  mixins: [SaveRouteMixin],
})
export default class DynamicContentPage extends Vue implements WithHead, WithAsyncData, OnMounted {
  private title!: string
  private content!: string

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.title,
        description: this.title,
        route: { name: 'page-slug', params: { slug: this.$route.params.slug } },
      },
    )
  }

  async asyncData (ctx: Context): Promise<AsyncComponentData | void> {
    const { slug } = ctx.route.params

    try {
      const { title, content } = await $api.PublicHandbookService.getSiteArticlesBySlug({
        slug
      })

      return {
        title,
        content,
      }
    } catch (e) {
      ctx.$sentry.captureException(e)
      ctx.error({ statusCode: 404 })
    }
  }

  get breadcrumbsItems () {
    return [{
      label: 'Home',
      path: this.localePath('index'),
      active: false,
    },
    {
      label: this.title,
      path: this.$route.path,
      active: true,
    }]
  }

  mounted () {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'Documentation',
    })
  }
}
